import React, { Component } from "react";
import classnames from "classnames";
import NewDeaths from "./graphs/az/NewDeaths";
import NewTests from "./graphs/az/NewTests";
import NewCases from "./graphs/az/NewCases";
import CasesDeathsSum from "./graphs/az/CasesDeathsSum";
import CurrentHospitalized from "./graphs/az/CurrentHospitalized";
import CasesDeathsMA from "./graphs/az/CasesDeathsMA";
import CasesDeathsPD from "./graphs/az/CasesDeathsPD";
import CumulativeCasesTests from "./graphs/az/CumulativeCasesTests";
import CasesTestsPD from "./graphs/az/CasesTestsPD";
import Testing from "./graphs/az/Testing";
import Summary from "./graphs/az/Summary";
import AzDbs from "./AzDbs";
import { Link } from "react-router-dom";

export default class Arizona extends Component {
  constructor() {
    super();
    this.state = {
      viewall: true,
      graph1: false,
      graph2: false,
      graph3: false,
      graph4: false,
      graph5: false,
      graph6: false,
      graph7: false,
      graph8: false,
      graph9: false,
      graph10: false,
    };
  }
  viewGraph = (graph) => {
    if (this.state.viewall) {
      this.setState({
        viewall: false,
      });
    }
    if (graph === 1) {
      this.setState({
        graph1: !this.state.graph1,
      });
    }
    if (graph === 2) {
      this.setState({
        graph2: !this.state.graph2,
      });
    }
    if (graph === 3) {
      this.setState({
        graph3: !this.state.graph3,
      });
    }
    if (graph === 4) {
      this.setState({
        graph4: !this.state.graph4,
      });
    }
    if (graph === 5) {
      this.setState({
        graph5: !this.state.graph5,
      });
    }
    if (graph === 6) {
      this.setState({
        graph6: !this.state.graph6,
      });
    }
    if (graph === 7) {
      this.setState({
        graph7: !this.state.graph7,
      });
    }
    if (graph === 8) {
      this.setState({
        graph8: !this.state.graph8,
      });
    }
    if (graph === 9) {
      this.setState({
        graph9: !this.state.graph9,
      });
    }
    if (graph === 10) {
      this.setState({
        graph10: !this.state.graph10,
      });
    }
    if (graph === 11) {
      this.setState({
        viewall: true,
        graph1: false,
        graph2: false,
        graph3: false,
        graph4: false,
        graph5: false,
        graph6: false,
        graph7: false,
        graph8: false,
        graph9: false,
        graph10: false,
      });
    }
  };
  last = (array, n) => {
    if (array == null) return void 0;
    if (n == null) return array[array.length - 1];
    return array.slice(Math.max(array.length - n, 0));
  };

  render() {
    let {
      newDates,
      dailyDMA,
      dailyDeaths,
      dailyTests,
      dailyTMA,
      dailyPositive,
      dailyPMA,
      positive,
      tests,
      currentHosp,
      currentHMA,
      positiveMA,
      deathMA,
      death,
    } = this.props;
    dailyDeaths = this.last(dailyDeaths, 90);
    dailyPositive = this.last(dailyPositive, 90);
    currentHosp = this.last(currentHosp, 90);
    dailyTests = this.last(dailyTests, 90);
    tests = this.last(tests, 90);
    death = this.last(death, 90);
    positive = this.last(positive, 90);
    newDates = this.last(newDates, 90);
    dailyDMA = this.last(dailyDMA, 90);
    dailyTMA = this.last(dailyTMA, 90);
    dailyPMA = this.last(dailyPMA, 90);
    currentHMA = this.last(currentHMA, 90);
    positiveMA = this.last(positiveMA, 90);
    deathMA = this.last(deathMA, 90);
    return (
      <div className="container">
        <div className="row titlerow">
          <div className="column">
            <h3>Arizona COVID-19 Status report</h3>
            <div className="alert-warning">
              <p>Last API data update March 7, 2021.</p>
            </div>
          </div>
          <span id="bestExp">* Use landscape mode on mobile devices for best experience *</span>
        </div>
        <div className="row titlerow">
          <div className="nav">
            <div className="tabs">
              <Link to="/pima90" className="tab tab-inactive">
                Pima
              </Link>
              <Link to="/arizona90" className="tab">
                Arizona
              </Link>
              <Link to="/arizona" className="tab tab-inactive">
                Full range
              </Link>
              <Link to="/arizona90" className="tab">
                Last 90 days
              </Link>
              <a href="https://pimadatapanelv1.netlify.app/vaccination-pima" className="tab ">
                Vaccination Pima
              </a>
            </div>
          </div>
        </div>
        <div className="row">
          <div id="casesdeaths">
            <CasesDeathsSum
              newDates={newDates}
              dailyDeaths={dailyDeaths}
              dailyDMA={dailyDMA}
              dailyPositive={dailyPositive}
              dailyPMA={dailyPMA}
              legendx={0.01358230584816907}
            />
          </div>
          <AzDbs />
        </div>
        <div className="row">
          <div className="links-to nav three columns">
            <div className="tabs">
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.viewall === true,
                })}
                onClick={() => this.viewGraph(11)}
              >
                View All
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph1 === true,
                })}
                onClick={() => this.viewGraph(1)}
                href="#newdeaths"
              >
                New deaths
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph2 === true,
                })}
                onClick={() => this.viewGraph(2)}
                href="#newtests"
              >
                New tests
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph3 === true,
                })}
                onClick={() => this.viewGraph(3)}
                href="#newcases"
              >
                New cases
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph4 === true,
                })}
                onClick={() => this.viewGraph(4)}
                href="#currenthosp"
              >
                Currently hospitalized
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph5 === true,
                })}
                onClick={() => this.viewGraph(5)}
                href="#casesdeathsma"
              >
                Cases and deaths (7 day avg.)
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph6 === true,
                })}
                onClick={() => this.viewGraph(6)}
                href="#casesdeathspd"
              >
                Cases and deaths per day
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph7 === true,
                })}
                onClick={() => this.viewGraph(7)}
                href="#cumulcasetest"
              >
                Cumulative cases and tests
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph8 === true,
                })}
                onClick={() => this.viewGraph(8)}
                href="#casetestspd"
              >
                Cases and tests per day
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph9 === true,
                })}
                onClick={() => this.viewGraph(9)}
                href="#testing"
              >
                Testing
              </div>
              <div
                className={classnames("tabgraph", {
                  tabgactive: this.state.graph10 === true,
                })}
                onClick={() => this.viewGraph(10)}
                href="#summary"
              >
                Summary
              </div>
            </div>
          </div>
          <div className="nine columns graphs">
            {this.state.graph1 || this.state.viewall ? (
              <div id="newdeaths">
                <NewDeaths
                  newDates={newDates}
                  dailyDeaths={dailyDeaths}
                  dailyDMA={dailyDMA}
                  legendx={0.01358230584816907}
                />
              </div>
            ) : null}
            {this.state.graph2 || this.state.viewall ? (
              <div id="newtests">
                <NewTests
                  newDates={newDates}
                  dailyTests={dailyTests}
                  dailyTMA={dailyTMA}
                />
              </div>
            ) : null}
            {this.state.graph3 || this.state.viewall ? (
              <div id="newcases">
                <NewCases
                  newDates={newDates}
                  dailyPositive={dailyPositive}
                  dailyPMA={dailyPMA}
                  legendx={0.01358230584816907}
                />
              </div>
            ) : null}
            {this.state.graph4 || this.state.viewall ? (
              <div id="currenthosp">
                <CurrentHospitalized
                  newDates={newDates}
                  currentHosp={currentHosp}
                  currentHMA={currentHMA}
                  legendx={0.01358230584816907}
                />
              </div>
            ) : null}
            {this.state.graph5 || this.state.viewall ? (
              <div id="casesdeathsma">
                <CasesDeathsMA
                  newDates={newDates}
                  positiveMA={positiveMA}
                  deathMA={deathMA}
                />
              </div>
            ) : null}
            {this.state.graph6 || this.state.viewall ? (
              <div id="casesdeathspd">
                <CasesDeathsPD
                  newDates={newDates}
                  dailyPositive={dailyPositive}
                  dailyPMA={dailyPMA}
                  dailyDeaths={dailyDeaths}
                  dailyDMA={dailyDMA}
                  legendx={0.01358230584816907}
                />
              </div>
            ) : null}
            {this.state.graph7 || this.state.viewall ? (
              <div id="cumulcasetest">
                <CumulativeCasesTests
                  newDates={newDates}
                  positive={positive}
                  tests={tests}
                />
              </div>
            ) : null}
            {this.state.graph8 || this.state.viewall ? (
              <div id="casetestspd">
                <CasesTestsPD
                  newDates={newDates}
                  dailyPositive={dailyPositive}
                  dailyPMA={dailyPMA}
                  dailyTests={dailyTests}
                  dailyTMA={dailyTMA}
                  legendx={0.01358230584816907}
                />
              </div>
            ) : null}
            {this.state.graph9 || this.state.viewall ? (
              <div id="testing">
                <Testing
                  newDates={newDates}
                  dailyTests={dailyTests}
                  tests={tests}
                />
              </div>
            ) : null}
            {this.state.graph10 || this.state.viewall ? (
              <div id="summary">
                <Summary
                  newDates={newDates}
                  dailyPositive={dailyPositive}
                  positive={positive}
                  death={death}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Arizona90.js